import React, { useRef, useEffect, useState } from "react";
import ProtectedRoute from "../../routes/protected";
import SideBarCompanyManagement from "../../components/sidebars/sidebarCompanyManagement";
import { useFormik } from 'formik';
import companyService from "../../services/data/company.service";
import useCompanyData from "../../context/company";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import FormCompanyLogo from '../../components/settings/forms/formCompanyLogo'
import CompanyLogoDefault from '../../assets/images/company-logo-default.png'
import { Toast } from 'primereact/toast';
import VerifyPerms from "../../context/userAccess";
import { Rating } from 'primereact/rating';


export default function CompanyConfig() {

    const { company } = useCompanyData()
    const companyId = localStorage.getItem('companyId')
    const [companyConfig, setCompanyConfig] = useState(null)
    const [loading, setLoading] = useState(true)
    const toast = useRef(null);
    useEffect(() => {
        if (company.config) {
            setCompanyConfig(company.config)
            setLoading(false)
        }
    }, [company])


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            company_id: companyId,
            settings: {
                performance: {
                    hide_cancel_rating_btn: companyConfig?.settings?.performance?.hide_cancel_rating_btn || company.settings?.performance?.hide_cancel_rating_btn || false,
                    rating_labels: companyConfig?.settings?.performance?.rating_labels || company.settings?.performance?.rating_labels || {
                        1: 'Insatisfatório',
                        2: 'Precisa Melhorar',
                        3: 'Dentro da Expectativa',
                        4: 'Acima da Expectativa',
                        5: 'Se Superou'
                    },
                }
            },
            // Campos individuais para os ratings
            rating_1: companyConfig?.settings?.performance?.rating_labels?.[1] || company.settings?.performance?.rating_labels?.[1] || 'Insatisfatório',
            rating_2: companyConfig?.settings?.performance?.rating_labels?.[2] || company.settings?.performance?.rating_labels?.[2] || 'Precisa Melhorar',
            rating_3: companyConfig?.settings?.performance?.rating_labels?.[3] || company.settings?.performance?.rating_labels?.[3] || 'Dentro da Expectativa',
            rating_4: companyConfig?.settings?.performance?.rating_labels?.[4] || company.settings?.performance?.rating_labels?.[4] || 'Acima da Expectativa',
            rating_5: companyConfig?.settings?.performance?.rating_labels?.[5] || company.settings?.performance?.rating_labels?.[5] || 'Se Superou'
        },
        onSubmit: values => {
            // Criar objeto com todos os ratings
            const ratingLabels = {
                1: values.rating_1,
                2: values.rating_2,
                3: values.rating_3,
                4: values.rating_4,
                5: values.rating_5
            };
            
            var data = {
                id: companyId,
                settings: {
                    performance: {
                        hide_cancel_rating_btn: values.settings.performance.hide_cancel_rating_btn,
                        rating_labels: ratingLabels
                    }
                }
            }
            
            // Enviar dados para a API usando o service
            companyService.updateCompanyConfig(data)
                .then(_response => {
                    toast.current.show({ 
                        severity: 'success', 
                        summary: 'Sucesso', 
                        detail: 'Configurações de performance atualizadas com sucesso!', 
                        life: 3000 
                    });
                }) 
                .catch(_error => {
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Erro', 
                        detail: 'Erro ao atualizar configurações de performance', 
                        life: 3000 
                    });
                });
        },
    });

    return (
        <ProtectedRoute>
            <div className="container-fluid">

                <Toast ref={toast} position="top-right" />

                <div className="row flex-nowrap">
                    <SideBarCompanyManagement />
                    <div className="col p-0 formMarginBottom">
                        <div className='text-bg-green p-3'>
                            <span className="fs-6 fw-bold">Configurações da Empresa</span>
                        </div>
                        {
                            VerifyPerms(['change_companyconfig']) ?
                            <>
                            {loading ? (
                                <div className="row mt-5">
                                    <div className="col-12 text-center">
                                        <div className="spinner-border text-success" role="status">
                                            <span className="visually-hidden">Carregando...</span>
                                        </div>
                                        <p className="mt-2">Carregando configurações...</p>
                                    </div>
                                </div>
                            ) : (
                            <div className="row mt-5">
                                <div className="col-lg-10 offset-lg-1">
                                    <div className="mb-4">
                                        <div className="text-start" style={{cursor: 'pointer'}} data-bs-toggle="modal" data-bs-target="#addPhoto">
                                            {
                                                company.logo ?
                                                <>
                                                <img src={`${company.logo}`} alt="logo" className="img-thumbnail img-fluid rounded-circle border-0" width="50" />
                                                <FontAwesomeIcon icon={solid('camera')} className="btn btn-sm text-green divBorderClean p-1 bg-white rounded position-relative" style={{top: '20px', right: '20px', width:'20px'}} />
                                                <span className="fs-4 position-relative" style={{left:'-15px'}} >{ company.name }</span>
                                                </>  
                                                : 
                                                <>
                                                <img src={CompanyLogoDefault} alt="logo" className="img-fluid rounded border-0" width="50" />
                                                <span className="fs-4 ms-2 position-relative" >{ company.name }</span>
                                                </>
                                            }
                                            
                                        </div>
                                        <div id="addPhoto" className="modal fade">
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title" id="exampleModalLabel">Atualizar Logo</h5>
                                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                    </div>
                                                    <div className="modal-body">
                                                        <FormCompanyLogo />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="rounded">
                                        <p className="fs-6 pt-3">Configurações da Empresa</p>
                                        <div className="row divBorderClean rounded p-3 bg-white">
                                            <p className="fw-bold font110 border-bottom pb-1">Avaliação de Desempenho</p>
                                            <div className="border rounded p-2 mb-2">
                                                                                                 <div className="form-check form-switch">
                                                     <label className="form-switch-label fw-bold">Ocultar botão de cancelar nota das Avaliações <Rating value={0} cancel={true} stars={0} /></label> ?
                                                     <input 
                                                         className="form-check-input" 
                                                         type="checkbox" 
                                                         role="switch" 
                                                         name='hide_cancel_rating_btn' 
                                                         checked={formik.values.settings.performance.hide_cancel_rating_btn} 
                                                         onChange={(e) => {
                                                             formik.setFieldValue('settings.performance.hide_cancel_rating_btn', 
                                                                e.target.checked, 
                                                                formik.handleSubmit()
                                                            );
                                                         }}
                                                     />
                                                 </div>
                                            </div>
                                            <div className="border rounded p-2">
                                                <div className="">
                                                    <label className="fw-bold mb-2">Trocar textos das notas (estrelas)?</label>
                                                    <table className="table table-border">
                                                        <tbody>
                                                            <tr>
                                                                <td className="text-center align-middle" width="100px">
                                                                    <Rating value={1} cancel={false} stars={1} />
                                                                </td>
                                                                <td className="w-100">
                                                                    <input 
                                                                        type="text"
                                                                        className="form-control" 
                                                                        name='rating_1' 
                                                                        value={formik.values.rating_1} 
                                                                        onChange={formik.handleChange} 
                                                                        placeholder="Ex: Insatisfatório"
                                                                    />
                                                                </td>
                                                            </tr>
                                                             <tr>
                                                                 <td className="text-center align-middle" width="100px">
                                                                     <Rating value={2} cancel={false} stars={2} />
                                                                 </td>
                                                                 <td className="w-100">
                                                                     <input 
                                                                         type="text" 
                                                                         className="form-control" 
                                                                         name='rating_2' 
                                                                         value={formik.values.rating_2} 
                                                                         onChange={formik.handleChange} 
                                                                         placeholder="Ex: Precisa Melhorar"
                                                                     />
                                                                 </td>
                                                             </tr>
                                                             <tr>
                                                                 <td className="text-center align-middle" width="100px">
                                                                     <Rating value={3} cancel={false} stars={3} />
                                                                 </td>
                                                                 <td className="w-100">
                                                                     <input 
                                                                         type="text" 
                                                                         className="form-control" 
                                                                         name='rating_3' 
                                                                         value={formik.values.rating_3} 
                                                                         onChange={formik.handleChange} 
                                                                         placeholder="Ex: Dentro da Expectativa"
                                                                     />
                                                                 </td>
                                                             </tr>
                                                             <tr>
                                                                 <td className="text-center align-middle" width="100px">
                                                                     <Rating value={4} cancel={false} stars={4} />
                                                                 </td>
                                                                 <td className="w-100">
                                                                     <input 
                                                                         type="text" 
                                                                         className="form-control" 
                                                                         name='rating_4' 
                                                                         value={formik.values.rating_4} 
                                                                         onChange={formik.handleChange} 
                                                                         placeholder="Ex: Acima da Expectativa"
                                                                     />
                                                                 </td>
                                                             </tr>
                                                             <tr>
                                                                 <td className="text-center align-middle" width="100px">
                                                                     <Rating value={5} cancel={false} stars={5} />
                                                                 </td>
                                                                 <td className="w-100">
                                                                     <input 
                                                                         type="text" 
                                                                         className="form-control" 
                                                                         name='rating_5' 
                                                                         value={formik.values.rating_5} 
                                                                         onChange={formik.handleChange} 
                                                                         placeholder="Ex: Se Superou"
                                                                     />
                                                                 </td>
                                                             </tr>
                                                        </tbody>
                                                    </table>

                                                    <button className="btn btn-success btn-sm btn-rounded px-4" onClick={() => {formik.handleSubmit()}}>Salvar</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            )}
                            </>
                            :
                            <p className='alert alert-warning m-3'>Você não tem permissão para acessar esta página</p>
                        }
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}